import { frontendURL } from 'dashboard/helper/URLHelper';

const KanbanView = () => import('./dashboard/kanban/KanbanView.vue');
const KanbanReports = () =>
  import('./dashboard/settings/reports/KanbanReports.vue');

export const kanbanRoutes = [
    {
        path: frontendURL('accounts/:accountId/kanban'),
        name: 'kanban_board',
        meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
            featureFlag: 'kanban_board',
        },
        component: KanbanView,
    },
    {
        path: frontendURL('accounts/:accountId/reports/kanban'),
        name: 'kanban_reports',
        meta: {
            permissions: ['administrator'],
            featureFlag: 'kanban_board',
        },
        component: KanbanReports,
    },
];

export default {
    routes: kanbanRoutes,
};
